import { Identifiable } from 'domain/models/base.model';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useOptions = <T extends Identifiable>(
	entities: T[],
	rel?: string
): {
	value: string | number;
	label: string;
}[] => {
	const { t } = useTranslation(['labels']);

	const options = useMemo(() => {
		return entities.map((e) => {
			let label = '' + e.id;
			if ((e as any).name) {
				label = (e as any).name;
			}

			return {
				value: e.id,
				label: t(`labels:select.${label}`, { defaultValue: label }),
			};
		});
	}, [entities]);
	return options;
};
